import { Module } from '../types';

// Mock course modules data
export const getCourseModules = async (): Promise<Module[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          id: '1-intro',
          title: 'Intro & EU AI Act',
          duration: '1:07',
          videoUrl: 'https://player.vimeo.com/video/1090757166?title=0&byline=0&portrait=0&badge=0&api=1&player_id=1-intro',
        },
        {
          id: '2-basics',
          title: 'Grundlagen der KI',
          duration: '6:17',
          videoUrl: 'https://player.vimeo.com/video/1090757148?title=0&byline=0&portrait=0&badge=0&api=1&player_id=2-basics',
        },
        {
          id: '3-chances',
          title: 'Chancen & Risiken',
          duration: '7:23',
          videoUrl: 'https://player.vimeo.com/video/1090757183?title=0&byline=0&portrait=0&badge=0&api=1&player_id=3-chances',
        },
        {
          id: '4-dos',
          title: 'Do\'s & Don\'ts',
          duration: '6:53',
          videoUrl: 'https://player.vimeo.com/video/1090757203?title=0&byline=0&portrait=0&badge=0&api=1&player_id=4-dos',
        },
        {
          id: '5-examples',
          title: 'Praxisbeispiele',
          duration: '6:06',
          videoUrl: 'https://player.vimeo.com/video/1090757219?title=0&byline=0&portrait=0&badge=0&api=1&player_id=5-examples',
        },
        {
          id: '6-guidelines',
          title: 'Unternehmensrichtlinien',
          duration: '4:26',
          videoUrl: 'https://player.vimeo.com/video/1090757134?title=0&byline=0&portrait=0&badge=0&api=1&player_id=6-guidelines',
        },
        {
          id: '7-summary',
          title: 'Zusammenfassung',
          duration: '4:13',
          videoUrl: 'https://player.vimeo.com/video/1090757120?title=0&byline=0&portrait=0&badge=0&api=1&player_id=7-summary',
        },
      ]);
    }, 500);
  });
};

// Generate and update course certificate
export const generateCertificate = async (userId: string): Promise<string> => {
  // In a real app, this would generate a certificate or link to one
  return new Promise((resolve) => {
    setTimeout(() => {
      const certificateUrl = 'https://superlative-froyo-e84338.netlify.app/';
      
      // Update user with certificate info
      const userJson = localStorage.getItem('currentUser');
      if (userJson) {
        const user = JSON.parse(userJson);
        user.certificateUrl = certificateUrl;
        localStorage.setItem('currentUser', JSON.stringify(user));
      }
      
      resolve(certificateUrl);
    }, 1000);
  });
};